import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@/redux/hooks';
import { userSelectors } from '@/redux/selectors';
import resultBlurred from '@/assets/images/analyze/mt-blured.webp';
import styles from './AmlMistrackInfo.module.sass';

interface AmlMistrackInfoProps {
  info: Record<string, any> | null;
  isTx?: boolean;
  isLoading?: boolean;
}

const AmlMistrackInfo: FC<AmlMistrackInfoProps> = ({
  info,
  isTx = false,
  isLoading,
}) => {
  const { t } = useTranslation();
  const hasServiceConnections =
    info?.services && !!Object.keys(info?.services).length;
  const { data: userData } = useAppSelector(userSelectors.getUserSlice);
  const isPromo = userData?.promoBalance;

  if (isLoading) {
    return (
      <div className={styles.box}>
        <div className={styles.skeleton}>
          <div className={styles.skeletonTitle} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.general}>
      <div className={styles.general__title}>
        {isTx && t('translation.mistrack_counterparty_title')}
        {!isTx && t('translation.mistrack_address_title')}
      </div>
      {isPromo && (
        <div className={styles.result}>
          <img src={resultBlurred} alt="" className={styles.example} />
        </div>
      )}
      {!isPromo && (
        <div className={styles.general__list}>
          <div />
          <>
            {!!info?.tags.length && (
              <dl>
                <dt>{t('translation.mistrack_tag_subtitle')}</dt>
                <dd>{info.tags.join(', ')}</dd>
              </dl>
            )}
            {!!hasServiceConnections && (
              <>
                {!!info?.services?.use_platform?.length && (
                  <dl>
                    <dt>{t('translation.mistrack_interactions')}</dt>
                    <dd>{info.services.use_platform.join(', ')}</dd>
                  </dl>
                )}
                {!!info?.services?.malicious_event?.length && (
                  <dl>
                    <dt>{t('translation.mistrack_events')}</dt>
                    <dd>
                      <span className={styles.events}>
                        {info.services.malicious_event.join(', ')}
                      </span>
                    </dd>
                  </dl>
                )}
                {!!info?.services?.relation_info?.length && (
                  <dl>
                    <dt>{t('translation.mistrack_info')}</dt>
                    <dd>{info.services.relation_info.join(', ')}</dd>
                  </dl>
                )}
              </>
            )}
          </>
        </div>
      )}
    </div>
  );
};

export default AmlMistrackInfo;
